import React from "react";
import { DraggableProvided } from "react-beautiful-dnd";
import { ComponentI } from "../../../../types";
import Card from "../../../../componentLibrary/Card";
import Input from "../../../../componentLibrary/Input";
import MultiSelectDropdown from "../../../../componentLibrary/MultiSelectDropdown";

export default function ActionDetailContentCard({
  component,
  handleContentChange,
  variableNames,
}: {
  component: ComponentI;
  handleContentChange: (
    id: string,
    field: string,
    value: string | boolean | string[],
  ) => void;
  variableNames: string[];
  provided: DraggableProvided;
}) {
  return (
    <Card>
      <div className="space-y-2">
        <Input
          value={component.content.label}
          onChange={(e) =>
            handleContentChange(component._id, "label", e.target.value)
          }
          label="Label"
          placeholder="Enter a label for the action detail button"
        />
        <div>
          <p className="font-bold">Linked Variables</p>
          <MultiSelectDropdown
            options={variableNames.map((variable) => ({
              value: variable,
              label: variable,
            }))}
            value={component.content.linked_variables.map((variable) => ({
              value: variable,
              label: variable,
            }))}
            onChange={(variable) => {
              handleContentChange(
                component._id,
                "linked_variables",
                variable.map((v) => v.value),
              );
            }}
            placeholder="Add a variable..."
          />
        </div>
      </div>
    </Card>
  );
}
